// eslint-disable-next-line simple-import-sort/imports
import { useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { getVehicleByPlate } from '@/apiCalls/glassGuideVehicleLookup/getVehicleByPlate';
// eslint-disable-next-line no-restricted-imports
import { Button, EButtonType } from '@/components/Button';
import {
    selectIsVehicleRegistrationKnown,
    selectVehicleDescription,
    selectVehicleAssetType,
    selectVehicleRegistrationNumber,
    selectVehicleRegistrationState,
    EVehicleAssetType,
    setIsVehicleRegistrationKnown,
    setVehicleBodyType,
    setVehicleDescription,
} from '@/context/borrower';
import { userFacingAssetTitle } from '@/utils/userFacingAssetTitle';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { Kilometers } from '@/UserInput/Kilometers';
import { RegistrationNumber } from '@/UserInput/RegistrationNumber';
import { RegistrationState } from '@/UserInput/RegistrationState';
import { ERROR_MESSAGE_REGO_NOT_FOUND } from '@/utils/constants';
import { useCopy } from '@/copy';

// eslint-disable-next-line no-restricted-imports
import { DescriptionBox } from '../DisplayVehicleResults/DescriptionBox';
// eslint-disable-next-line simple-import-sort/imports
export const testId = 'VehicleDetailsRegoKnown';

interface IVehicleDetailsRegoKnownProps {
    showErrors: boolean;
}

export function VehicleDetailsRegoKnown({
    showErrors,
}: IVehicleDetailsRegoKnownProps): JSX.Element {
    const baseId = 'screen-vehicleDetailsRegoUnknown';
    const [loading, setLoading] = useState(false);
    // Add state for the make image URL
    const [makeImageUrl, setMakeImageUrl] = useState<string | undefined>(
        undefined
    );
    const dispatch = useAppDispatch();
    const { quietFallbackPrompt } = useCopy();
    const assetTitle = userFacingAssetTitle();
    const description = useAppSelector(selectVehicleDescription);
    const assetType = useAppSelector(selectVehicleAssetType);
    const partner = useAppSelector((state) => state.displayReducer.partner.id);
    const disabledGlassesGuideVinLookup = useAppSelector(
        (state) => state.displayReducer.partner.disabledGlassesGuideVinLookup
    );
    // ***** CONSTANTS *****
    const handleOnClickFindVehicle = async (): Promise<void> => {
        setLoading(true);

        // Check if glasses guide VIN lookup is disabled for this brand
        if (disabledGlassesGuideVinLookup) {
            console.log(
                'Glasses guide plate lookup is disabled for this brand'
            );
            setLoading(false);
            setMakeImageUrl(undefined);
            dispatch(setVehicleDescription(ERROR_MESSAGE_REGO_NOT_FOUND));
            dispatch(setVehicleBodyType(undefined));
            return;
        }

        await getVehicleByPlate(
            vehicleRegistrationNumber,
            vehicleState,
            partner
        )
            .then((response) => {
                console.log('1', response);
                setLoading(false);
                setMakeImageUrl(response.makeImageUrl);
                dispatch(setVehicleDescription(response.description));
                dispatch(setVehicleBodyType(response.bodyType || undefined));
            })
            .catch(() => {
                console.log('Catch');
                setLoading(false);
                setMakeImageUrl(undefined);
                dispatch(setVehicleDescription(ERROR_MESSAGE_REGO_NOT_FOUND));
                dispatch(setVehicleBodyType(undefined));
            });
    };

    const isRegistrationKnown = useAppSelector(
        selectIsVehicleRegistrationKnown
    );
    const vehicleRegistrationNumber = useAppSelector(
        selectVehicleRegistrationNumber
    );
    const vehicleState = useAppSelector(selectVehicleRegistrationState);
    const isTruckAsset = assetType === EVehicleAssetType.TRUCK_GT_4_5;

    const requiredFieldsPresentInState =
        isRegistrationKnown && vehicleRegistrationNumber && vehicleState
            ? true
            : false;

    function handleClick(): void {
        dispatch(setIsVehicleRegistrationKnown(false));
    }

    return (
        <div data-testid={testId}>
            <RegistrationNumber showErrors={showErrors} baseId={baseId} />
            <Kilometers showErrors={showErrors} baseId={baseId} />
            <RegistrationState showErrors={showErrors} baseId={baseId} />
            <div className='py-4'>
                {requiredFieldsPresentInState === true && !description ? (
                    <Button onClick={handleOnClickFindVehicle}>
                        {`Find ${assetTitle}`}
                    </Button>
                ) : (
                    <Button
                        onClick={handleOnClickFindVehicle}
                        type={EButtonType.FULL_ROUNDED_DISABLED}
                        id={`${baseId}-button-findVehicle`}
                    >
                        {`Find ${assetTitle}`}
                    </Button>
                )}
            </div>
            <div>
                {loading && <div className='text-center'>.....Loading</div>}

                {!loading && description !== undefined && (
                    <DescriptionBox
                        key={undefined}
                        selected
                        content={description}
                        makeImageUrl={makeImageUrl}
                    />
                )}
            </div>
            {!isTruckAsset && (
                <>
                    <p
                        className={`${
                            quietFallbackPrompt ? 'text-sm' : 'text-lg'
                        } px-4 text-center pb-4`}
                    >
                        {`Can't find the ${assetTitle.toLowerCase()}?`} <br />
                    </p>
                    {/* todo: conditional logic to show => Not caravan */}
                    <Button
                        type={EButtonType.SECONDARY_OUTLINE}
                        onClick={handleClick}
                    >
                        Search Manually
                    </Button>
                </>
            )}
        </div>
    );
}
